import { Mail, MapPin } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0A192F] text-white pt-16 pb-10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img
                src={BUSINESS.logoUrl}
                alt="Perficient Building Services Ltd"
                className="w-11 h-11 rounded-md object-cover bg-[#0A192F]"
              />
              <span className="font-heading font-semibold text-white">
                {BUSINESS.name}
              </span>
            </div>
            <p className="mt-4 text-sm text-white/70 max-w-xs leading-relaxed">
              Trusted electrical, plumbing, gas, HVAC and property maintenance
              for homes and businesses.
            </p>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">
              Contact
            </p>
            <ul className="mt-4 space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-white/70" />
                <a
                  data-testid="footer-email"
                  href={BUSINESS.emailHref}
                  className="hover:underline break-all"
                >
                  {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-white/70" />
                <span>{BUSINESS.area}</span>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-white/60">
              Sections
            </p>
            <ul className="mt-4 grid grid-cols-2 gap-y-2 text-sm">
              {[
                { id: "home", label: "Home" },
                { id: "services", label: "Services" },
                { id: "about", label: "About" },
                { id: "contact", label: "Contact" },
              ].map((l) => (
                <li key={l.id}>
                  <a
                    data-testid={`footer-link-${l.id}`}
                    href={`#${l.id}`}
                    className="text-white/80 hover:text-white"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <span>
            © {year} {BUSINESS.name}. All rights reserved.
          </span>
          <span>Quality workmanship · Domestic & Commercial</span>
        </div>
      </div>
    </footer>
  );
}
